import { svg } from 'lit';

export const emailReadIcon = svg`
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5939 2.08619C11.8524 1.97127 12.1476 1.97127 12.4061 2.08619L21.4061 6.08619C21.7673 6.24669 22 6.60481 22 7V19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19V7C2 6.60481 2.23273 6.24669 2.59386 6.08619L11.5939 2.08619ZM4 8.69951V18H20V8.69951L12.4856 12.8742C12.1836 13.0419 11.8164 13.0419 11.5144 12.8742L4 8.69951ZM18.7617 7.09953L12 4.09432L5.23828 7.09953L12 10.856L18.7617 7.09953Z" fill="currentColor"/>
  `;
